<template lang="html">
  <svg class="icon stitched-outfits" viewBox="0 0 32 32">
    <path
      d="M22.229,4.514c-2.547,0-4.85,1.334-5.919,3.414c-1.07-2.079-3.401-3.414-5.948-3.414  c-3.981,0-9.319,3.209-6.888,11.963C6.251,25.034,16.31,30.065,16.31,30.063c0,0.002,10.044-5.029,12.821-13.586  C31.562,7.723,26.209,4.514,22.229,4.514z"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.menu__item.router-link-active .icon {
  &.stitched-outfits {
    animation: strokeStitchedOutfits 1.5s reverse;
  }

  @keyframes strokeStitchedOutfits {
    100% {
      stroke-dashoffset: 400;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/MobileNavbar/svgs/SvgStitchedOutfits.vue